import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import { Drawer, Grid } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import FilterListIcon from '@material-ui/icons/FilterList';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import MultiSelect from './multiselect'
import { init as initProvinces } from 'covid-web/provinces'
import Ploty from './ploty'
import { getProvinces, getRegions } from 'covid-web/totaleCasi';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  menuButton: {
    border:'solid 1px #FFF',
    borderRadius:'15px',
    fontSize:'10px',
    // marginRight: theme.spacing(2),
    padding:'3px',
    fontSize:'1rem'
  },
  // necessary for content to be below app bar
  drawerPaper: {
    // width: drawerWidth,
    background: '#2c2e35',
    color: '#FFF',
    textAlign: 'center'
  },
  content: {
    // flexGrow: 1,
    // padding: theme.spacing(3),
  },
}));

export default function PersistentDrawerRight(props) {
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [types, setTypes] = React.useState('Provincia');
  const [province, setProvince] = React.useState([])
  const [regioni, setRegioni] = React.useState([])
  const [regionValues, setRegionValues] = React.useState(["Lombardia", "Veneto"])
  const [provinceValues, setProvinceValues] = React.useState(["Bergamo", "Milano", "Venezia"])
  function setSelectedProvince(newValue) {
    setProvinceValues(newValue)
  }
  function setSelectedRegion(newValue) {
    setRegionValues(newValue)
  }
  React.useEffect(() => {

    const foo = async () => {
      await initProvinces()

      setProvince(getProvinces().sort())
      setRegioni(getRegions().sort())
    }

    foo()

  }, [])

  const handleType = (event, newFormats) => {
    setTypes(newFormats);
  };


  const drawer = (
    <div>
      <div className={classes.toolbar} >
        <Grid container style={{ position: 'relative', top: '15px' }}>
          <Grid item xs={6}>
            <Typography variant="h6" noWrap style={{ paddingLeft: 10, paddingBottom: 20 }}>
              Filtra
           </Typography>
          </Grid>
          <Grid item xs={6}>
            <ArrowBackIosIcon style={{ float: 'right', cursor: 'pointer' }}
              onClick={handleDrawerToggle}

            />

          </Grid>

        </Grid>


      </div>
      <Divider />
      <ToggleButtonGroup exclusive value={types} onChange={handleType} aria-label="aree_buttons">
        <ToggleButton value="Nazione" aria-label="bold">
          Nazione
        </ToggleButton>
        <ToggleButton value="Regione" aria-label="bold">
          Regioni
            </ToggleButton>
        <ToggleButton value="Province" aria-label="bold">
          Province
            </ToggleButton>
      </ToggleButtonGroup>
      <Divider />
      <div style={{ display: types === 'Regione' ? 'block' : 'none' }}>
        <MultiSelect id="regione" values={regionValues} setvalue={setSelectedRegion} type={'Regioni'} lists={regioni} />
      </div>
      <div style={{ display: types === 'Province' ? 'block' : 'none' }}>
        <MultiSelect id="province" values={provinceValues} setvalue={setSelectedProvince} type={'Province'} lists={province} />
      </div>
      <div style={{ display: types === 'Nazione' ? 'block' : 'none' }}>
        <MultiSelect id="nazione" values={["Italia"]} type={'Nazione'} lists={["Italia"]} />
      </div>

    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/*
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
        </Toolbar>
      </AppBar>
      */}
      <nav className={classes.drawer} aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <main className={classes.content}>
        <div className={classes.toolbar} />
      {!mobileOpen ?
        <Ploty 
          handleDrawerToggle={handleDrawerToggle}
          types={types}
          field={
           types === "Regione"
            ? 'denominazione_regione'
            : 'denominazione_provincia'}
          regionValues={regionValues}
          provinceValues={provinceValues}
        /> :
        <></>}
      </main>
    </div>

  );
}
